import React, { useState } from 'react';
import { Input, Form, Row, Radio } from 'antd';
import {
  DrawerEdit,
  FormItemWrap,
  useCrudEditContext
} from 'react-structure-admin';
import { federalTaxNumberValidator } from 'util/validators';
import { MaskedInput } from 'antd-mask-input';
import { AddressV2, ResCol } from 'components';

const CustomerEdit = (props) => {
  const { form } = useCrudEditContext();
  const [isLegalPerson, setIsLegalPerson] = useState(
    props?.data?.isLegalPerson
  );

  const handleSubmit = ({ ...rest }) => {
    return {
      ...rest,
      isLegalPerson
    };
  };

  const handleBeforeBinding = ({ ...rest }) => {
    setIsLegalPerson(rest.isLegalPerson ?? false);

    return {
      ...rest
    };
  };

  const toggler = () => {
    form.setFieldsValue({ federalTaxNumber: '' });
    setIsLegalPerson(!isLegalPerson);
  };

  const postalCodeChangeHandle = (sender) => {
    const federalTaxNumber = sender.target.value.replace(/\D/g, '');

    if (federalTaxNumber.length === 14) {
      setIsLegalPerson(true);
    }
  };

  return (
    <DrawerEdit
      {...props}
      size="sm"
      onSubmit={handleSubmit}
      onBeforeBinding={handleBeforeBinding}
    >
      <Form layout="vertical">
        <div className="gx-flex-row gx-align-items-center gx-justify-content-center">
          <Radio.Group value={isLegalPerson} onChange={toggler}>
            <Radio.Button value={false}>Pessoa Física</Radio.Button>
            <Radio.Button value>Pessoa Jurídica</Radio.Button>
          </Radio.Group>
        </div>

        {isLegalPerson ? (
          <>
            <Row>
              <ResCol span={24}>
                <Row gutter={[10, 0]}>
                  <ResCol span={8}>
                    <FormItemWrap
                      label="CNPJ"
                      name="federalTaxNumber"
                      whitespace
                      autoFocus
                      validateTrigger="onBlur"
                      rules={[{ validator: federalTaxNumberValidator }]}
                      required
                    >
                      <MaskedInput
                        onChange={postalCodeChangeHandle}
                        mask="11.111.111/1111-11"
                      />
                    </FormItemWrap>
                  </ResCol>
                  <ResCol span={16}>
                    <FormItemWrap
                      label="Nome fantasia"
                      name="name"
                      required
                      whitespace
                    >
                      <Input maxLength={100} />
                    </FormItemWrap>
                  </ResCol>
                </Row>
                <Row gutter={[10, 0]}>
                  <ResCol span={12}>
                    <FormItemWrap
                      label="Razão Social"
                      name="legalName"
                      required
                      whitespace
                    >
                      <Input />
                    </FormItemWrap>
                  </ResCol>
                  <ResCol span={6}>
                    <FormItemWrap label="Insc Estadual" name="stateTaxNumber">
                      <Input />
                    </FormItemWrap>
                  </ResCol>
                  <ResCol span={6}>
                    <FormItemWrap label="Insc Municipal" name="cityTaxNumber">
                      <Input />
                    </FormItemWrap>
                  </ResCol>
                </Row>
                <Row gutter={[10, 0]}>
                  <ResCol span={11}>
                    <FormItemWrap
                      validateTrigger="onBlur"
                      label="Email"
                      name="email"
                      type="email"
                    >
                      <Input />
                    </FormItemWrap>
                  </ResCol>
                  <ResCol span={6}>
                    <FormItemWrap
                      label="Telefone fixo"
                      name="phoneNumber"
                      type="phone"
                    >
                      <MaskedInput
                        mask="(11) 1111-1111"
                        placeholder="(__) _____-____"
                      />
                    </FormItemWrap>
                  </ResCol>
                  <ResCol span={7}>
                    <FormItemWrap
                      label="Celular"
                      name="mobileNumber"
                      type="mobileNumber"
                    >
                      <MaskedInput
                        mask="(11) 11111-1111"
                        placeholder="(__) _____-____"
                      />
                    </FormItemWrap>
                  </ResCol>
                </Row>
              </ResCol>
            </Row>
          </>
        ) : (
          <>
            <Row>
              <ResCol span={24}>
                <FormItemWrap
                  label="CPF"
                  name="federalTaxNumber"
                  whitespace
                  autoFocus
                  validateTrigger="onBlur"
                  rules={[{ validator: federalTaxNumberValidator }]}
                  required
                >
                  <MaskedInput
                    mask="111.111.111-11"
                    placeholder="___.___.___-__"
                  />
                </FormItemWrap>
                <FormItemWrap label="Nome" name="name" required whitespace>
                  <Input maxLength={100} />
                </FormItemWrap>
                <Row gutter={[10, 0]}>
                  <ResCol span={11}>
                    <FormItemWrap
                      validateTrigger="onBlur"
                      label="Email"
                      name="email"
                      type="email"
                    >
                      <Input />
                    </FormItemWrap>
                  </ResCol>
                  <ResCol span={6}>
                    <FormItemWrap
                      label="Telefone fixo"
                      name="phoneNumber"
                      type="phone"
                    >
                      <MaskedInput
                        mask="(11) 1111-1111"
                        placeholder="(__) _____-____"
                      />
                    </FormItemWrap>
                  </ResCol>
                  <ResCol span={7}>
                    <FormItemWrap
                      label="Celular"
                      name="mobileNumber"
                      type="mobileNumber"
                    >
                      <MaskedInput
                        mask="(11) 11111-1111"
                        placeholder="(__) _____-____"
                      />
                    </FormItemWrap>
                  </ResCol>
                </Row>
              </ResCol>
            </Row>
          </>
        )}

        <AddressV2 required />
      </Form>
    </DrawerEdit>
  );
};
export default CustomerEdit;
